import moment from "moment-timezone";
import { aConfig, ResourceNotFoundError, setConfig } from "../api"

const TIME_ZONE_STORAGE_KEY = "pb-time-zone"
const DEFAULT_TIME_ZONE = "America/Los_Angeles"

export const timeZone = () => {
    return sessionStorage.getItem(TIME_ZONE_STORAGE_KEY) || DEFAULT_TIME_ZONE
}
export const setTimeZone = (timeZone: string):Promise<void> =>  {
    return setConfig({timeZone}).then( () => {
        sessionStorage.setItem(TIME_ZONE_STORAGE_KEY, timeZone)
    })  
}

export const fetchTimeZone = ():Promise<string> => {
    return aConfig("timeZone").then( 
        response => {
            const timeZone = response.data.value
            sessionStorage.setItem(TIME_ZONE_STORAGE_KEY, timeZone)
            return timeZone
        },
        error => {
            if (error instanceof ResourceNotFoundError) {
                // okay for a server not to have this config val
               return null 
            }  else {
                throw error
            }
        }
     )
}

export const localDate = (date: Date): Date => {
    const tz = timeZone()
    if (tz && date) {
        const utc = date.toISOString()
        const localMoment = moment.tz(utc, tz)
        return new Date(localMoment.format("YYYY-MM-DDTHH:mm:ss.SSS")); 
    } else {
        return date
    }
}
export const localDatefromString = (date: string): Date => {
    const tz = timeZone()
    if (tz && date) {
        const localMoment = moment.tz(date, tz)
        return new Date(localMoment.format("YYYY-MM-DDTHH:mm:ss.SSS")); 
    } else {
        return new Date(date)
    }
}
